import type { CompanySanctionMatchInput } from '@ballerine/common';
import { extractCompanySanctionCategories } from '@ballerine/common';

export type CompanySanctionMatch = {
  id?: string;
  primaryName?: string;
  lastReviewed?: string;
  labels?: string[];
  reasonsForMatch?: string[];
  sources?: Array<{ url: string; categories?: string[] }>;
  fullReport?: Record<string, unknown>;
  alternativeNames?: Array<{ name: string; type?: string }> | string[];
  officialLists?: Array<{ description: string }>;
  furtherInformation?: string[];
  linkedIndividuals?: Array<{
    firstName?: string;
    middleName?: string;
    lastName?: string;
    description?: string;
  }>;
  places?: Array<{
    country?: string;
    city?: string;
    address?: string;
  }>;
};

// useSectionData adapts the raw vendor match into this flatter shape but keeps
// the original under `fullReport` — the canonical extractor reads from there.
// `labels`/`sources` on the adapted shape are themselves derived from
// `entity.categories`/`entity.sources`, so passing fullReport covers them.
export const extractSanctionTags = (match: CompanySanctionMatch): string[] =>
  extractCompanySanctionCategories(match.fullReport as CompanySanctionMatchInput);
